import {useEffect, useRef} from "react";
import {getOrderCeoApi, getOrderListApi} from "api/orderApi";

export const useGetOrderCeoApi = async (setters, data) => {
  const previousDataRef = useRef();

  useEffect(() => {
    const response = async () => {
      if (data) {
        const getData = await getOrderCeoApi(data);

        setters.setList?.(getData.data);
        setters.setTotalPage?.(getData.totalPage);
        setters.setTotalCount?.(getData.totalCount);
      }
    }
    if (JSON.stringify(previousDataRef.current) !== JSON.stringify(data)) {
      response();
      previousDataRef.current = data;
    }
  }, [data, setters]);
}

export const useGetOrderListHook = async (setters, data) => {
  const previousDataRef = useRef();

  useEffect(() => {
    const response = async () => {
      if (data) {
        const orderData = await getOrderListApi(data);
        setters.setList?.(orderData.data || []);
        setters.setTotalCount?.(orderData.totalSize || 0);
      }
    }
    if (JSON.stringify(previousDataRef.current) !== JSON.stringify(data)) {
      response();
      previousDataRef.current = data;
    }
  }, [data, setters]);
}